<template>
  <div class="enlace">
    <a href="#" @click.prevent="accion()">
      <fai v-if="tipo == 'pdf'" :icon="['far', 'file-pdf']" />
      {{ titulo }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    titulo: { type: String, required: true },
    tipo: { type: String, required: false, default: null },
    accion: {
      type: Function,
      required: false,
      default: function() {
        console.log("Pulsado en " + this.titulo);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.enlace {
  font-size: 110%;
  margin-bottom: 0.75rem;
  a {
    color: white;
  }
}
</style>
